import { Filesystem as FileSystemPlugin, Directory } from "@capacitor/filesystem";
import { Logger } from "@core/helpers/logger.helpers";

export class Filesystem {
  /**
   * Returns the Capacitor Filesystem plugin instance
   * @readonly
   */
  static get plugin() {
    return FileSystemPlugin;
  }

  /**
   * Write a file to disk in the specified location on device
   // https://capacitorjs.com/docs/v2/apis/filesystem#writefile
   * @returns {Promise<FileWriteResult>} DeviceInfo
   */
  static async writeFile({ path, data }) {
    try {
      // Vérifier et demander les permissions
      const permissionStatus = await Filesystem.plugin.checkPermissions();

      if (permissionStatus.publicStorage !== "granted") {
        Logger.error("### Filesystem - permission error", permissionStatus.publicStorage);
        await Filesystem.plugin.requestPermissions();
      }

      const result = await Filesystem.plugin.writeFile({
        path,
        data,
        directory: Directory.Documents,
      });

      Logger.log("### Filesystem - writeFile - result", result.uri);
      return result;
    } catch (error) {
      Logger.error("### Filesystem - writeFile - error", error);
      throw error;
    }
  }
}
